export const copyLink = async (path = "/") => {
  await navigator.clipboard.writeText(document.location.origin + path)
}
